export enum AssetStateName {
  pending = "pending",
  closed = "closed",
  suceeded = "suceeded",
}
